
angular.module('qkr.merchant.reports').factory('byorService', ($http, appConfig, utils) => ({

    resolve(routeParams, isNewReport) {
        if (isNewReport) {
            return null;
        } else {
            return {id: routeParams.id};
        }
    },

    getColumns() {
        return $http.get(appConfig.apiUrl + 'byorTransactionReportSpec/getColumns', {withCredentials: true})
            .then(response => response.data);
    },

    getByorReportSpec(id) {
        return $http.get(appConfig.apiUrl + 'byorTransactionReportSpec/get/' + id, {withCredentials: true})
            .then((response) => response.data);
    },

    createByorReport(report, shouldSave) {
        const reportSpec = {
            id: report.id,
            name: report.name,
            scheduleInterval: report.scheduleInterval,
            scheduleHour: report.scheduleHour,
            scheduleDay: report.scheduleDay,
            scheduleDayOfMonth: report.scheduleDayOfMonth,
            scheduleMinute: report.scheduleMinute,
            emailList: report.emailList,
            reportSubType: 'BYOR',
            merchantLocs: [],
            byor: {
                cols: []
            }
        };

        angular.forEach(report.selectableDepts, d => {
            if (d.selected) {
                reportSpec.merchantLocs.push({id: d.id});
            }
        });

        angular.forEach(report.selectedColumns, c => {
            reportSpec.byor.cols.push(c.name);
        });

        if (shouldSave) {
            if (report.id !== null) {
                return $http.post(appConfig.apiUrl + 'byorTransactionReportSpec/update',
                    reportSpec, {withCredentials: true})
                    .then(response => response.data);
            } else {
                return $http.post(appConfig.apiUrl + 'byorTransactionReportSpec/create',
                    reportSpec, {withCredentials: true})
                    .then(response => response.data);
            }
        } else {
            const cmd = {
                reportSpec,
                startTime: utils.dateTimeToServerDateTimeString(report.date.startDate, report.date.startTime),
                endTime: utils.dateTimeToServerDateTimeString(report.date.endDate, report.date.endTime)
            };
            return $http.post(appConfig.apiUrl + 'byorTransactionReportSpec/generate', cmd, {withCredentials: true})
                .then(response => response.data);
        }
    },

    update(reportSpec) {
        return $http.post(appConfig.apiUrl + 'byorTransactionReportSpec/update', reportSpec, {withCredentials: true})
            .then(response => response.data);
    },

    create(reportSpec) {
        return $http.post(appConfig.apiUrl + 'byorTransactionReportSpec/create', reportSpec, {withCredentials: true})
            .then(response => response.data);
    },

    schedule(scheduledReportSpec) {
        return $http.post(appConfig.apiUrl + 'byorTransactionReportSpec/generate', scheduledReportSpec, {withCredentials: true})
            .then(response => response.data);
    },

    createReportSpec(report) {
        return {
            id: report.id,
            name: report.name,
            scheduleInterval: report.scheduleInterval,
            scheduleHour: report.scheduleHour,
            scheduleDay: report.scheduleDay,
            scheduleDayOfMonth: report.scheduleDayOfMonth,
            scheduleMinute: report.scheduleMinute,
            emailList: report.emailList,
            reportSubType: 'BYOR',
            merchantLocs: report.selectableDepts
                .filter(d => d.selected)
                .map(d => { return { id: d.id }; }),
            byor: {
                cols: report.selectedColumns.map(c => c.name)
            }
        };
    },

    createSchuledReportSpec(report) {
        return {
            reportSpec: this.createReportSpec(report),
            startTime: utils.dateTimeToServerDateTimeString(report.date.startDate, report.date.startTime),
            endTime: utils.dateTimeToServerDateTimeString(report.date.endDate, report.date.endTime)
        };
    }

}));



// WEBPACK FOOTER //
// ./src/reports/outlet/shared/byor.services.js